module.exports = __webpack_public_path__ + "img/uk-channel-banner.f978d6c2.png";